import Card from '@/components/Card/Card.vue';
import FetchData from '@/components/DataProvider/FetchData.vue';
import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
import Pagination from '@/components/Pagination/Pagination.vue';
import { useRouteQuery } from '@/composables';
import { mapQueryToApiV2 } from '@/util/query';
import { computed, defineComponent, onMounted, ref, } from '@vue/composition-api/dist/vue-composition-api';
import { FILTER_DEBOUNCE } from '@/constants/filters';
import { DEFAULT_CARD_LIMIT } from '@/constants/pagination';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useGetters } = createNamespacedHelpers('user');
export default defineComponent({
    name: 'ClientsList',
    components: {
        Card,
        FetchData,
        IconSpinner,
        Pagination,
    },
    props: {
        additionalQuery: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, ctx) {
        const { hasAdminRights } = useGetters(['hasAdminRights']);
        const clientsList = ref([]);
        const listUpdatesCounter = ref(0);
        const lastPage = ref();
        const { routeQuery, changePage, selectLimit } = useRouteQuery(ctx);
        const computedQuery = computed(() => {
            const { q, ...query } = mapQueryToApiV2(routeQuery.value);
            return {
                ...query,
                name: q,
                ...props.additionalQuery,
            };
        });
        const currentPage = computed(() => {
            return computedQuery.value?.page ?? 1;
        });
        const updateList = (data) => {
            clientsList.value = data.nodes;
            lastPage.value = Math.ceil(data.totalCount / (computedQuery.value?.perPage || DEFAULT_CARD_LIMIT));
        };
        onMounted(() => {
            selectLimit(DEFAULT_CARD_LIMIT);
        });
        return {
            FILTER_DEBOUNCE,
            computedQuery,
            hasAdminRights,
            clientsList,
            listUpdatesCounter,
            lastPage,
            currentPage,
            changePage,
            updateList,
        };
    },
});
